import { Image } from '#/components/Image/Image';
import { H2 } from '#/components/Text/H2';
import { HeadingSmall } from '#/components/Text/HeadingSmall';
import { useAppConfig } from '#/config/AppConfigContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors } from '#/theme/theme';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { ViewUserProfilePageContentContainer } from './ViewUserProfilePage.styled';
import {
  ViewUserProfilePageNotFoundHolder,
  ViewUserProfilePageNotFoundImageHolder,
  ViewUserProfilePageNotFoundTextHolder,
} from './ViewUserProfilePageNotFound.styled';

export function ViewUserProfilePageNotFound() {
  const { appConfig } = useAppConfig();
  const { i18n } = useI18n();

  return (
    <ViewUserProfilePageContentContainer>
      <ViewUserProfilePageNotFoundHolder>
        <ViewUserProfilePageNotFoundImageHolder>
          <Image
            src={getStaticImageSrc(
              'private-profile.svg',
              appConfig.idealist.staticImgPath,
            )}
            alt="Illustration"
          />
        </ViewUserProfilePageNotFoundImageHolder>
        <ViewUserProfilePageNotFoundTextHolder>
          <HeadingSmall my={0} color={colors.lightContentGrey}>
            {i18n('profiles')}
          </HeadingSmall>
          <H2>{i18n('This profile does not exist, or is set to private')}</H2>
        </ViewUserProfilePageNotFoundTextHolder>
      </ViewUserProfilePageNotFoundHolder>
    </ViewUserProfilePageContentContainer>
  );
}
